import { css } from '@emotion/css';

export const enterClassName = css({
  opacity: 0,
});

export const enterActiveClassName = css({
  opacity: 1,
  transition: 'opacity 0.2s',
});

export const exitClassName = css({
  opacity: 1,
});

export const exitActiveClassName = css({
  opacity: 0,
  transition: 'opacity 0.2s',
});
